var _ellipse, _rect, _path, _path2, _ellipse2, _g, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoRows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 174,
    viewBox: "0 0 174 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.035,
    cy: 71.0352,
    rx: 71.035,
    ry: 71.0352,
    transform: "matrix(-0.965926 0.25882 -0.258819 -0.965926 174 137.229)",
    fill: "#EBEBEB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 52.7178,
    y: 96.5009,
    width: 67.9077,
    height: 3.57437,
    rx: 1.78718,
    fill: "#EBEBEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.313 147.511L90.2734 110.962C89.1739 109.781 89.2049 107.943 90.3435 106.8L98.3366 98.777C99.4712 97.6381 101.302 97.5961 102.488 98.6816L140.693 133.658C135.976 139.065 130.453 143.746 124.313 147.511Z",
    fill: "#516674"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3105 97.7685L90.2458 106.737L97.8407 99.1138L88.9055 90.1454L81.3105 97.7685Z",
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.8244,
    cy: 60.1013,
    rx: 48.2502,
    ry: 48.4293,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_15201_8482)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.8249,
    cy: 60.1014,
    rx: 35.7409,
    ry: 35.8736,
    fill: "#EBEBEB"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5162 51.4491C38.0802 54.7247 37.0807 58.421 37.0807 60.1013C37.0807 62.8255 34.8805 65.034 32.1663 65.034C29.4522 65.034 27.252 62.8255 27.252 60.1013C27.252 55.9522 29.1564 50.2318 32.6399 45.5478C36.2354 40.7135 42.0241 36.3351 50.0368 36.3351C52.7509 36.3351 54.9511 38.5435 54.9511 41.2677C54.9511 43.9919 52.7509 46.2003 50.0368 46.2003C45.9869 46.2003 42.8404 48.3241 40.5162 51.4491Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_15201_8482",
    x: 16.084,
    y: 24.2278,
    width: 71.4814,
    height: 71.7471,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.604167 0 0 0 0 0.589063 0 0 0 0 0.589063 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_15201_8482"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: -3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.975 0 0 0 0 0.975 0 0 0 0 0.975 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_15201_8482",
    result: "effect2_innerShadow_15201_8482"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRows);
export default __webpack_public_path__ + "static/media/noRows.d48dae217a282a7185d2af03aa1e4df0.svg";
export { ForwardRef as ReactComponent };